import state from "./moduleReceiveTelephoneState";
import mutations from "./moduleReceiveTelephoneMutations";
import actions from "./moduleReceiveTelephoneActions";
import getters from "./moduleReceiveTelephoneGetters";

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}